import { IOption } from '@user/components/Filters'
import { GainMoreCustomersData } from './widgets/gainMoreCustomers/typings'
import { OverdueNextActionDatesData } from './widgets/overdueNextActionDates/typings'
import { UpcomingFollowUpsData } from './widgets/upcomingFollowUps/typings'
import { defaultGUIDValue } from '@user/components/Dashboard/widgets/utils/constants'

export const mapDashboardDataToFilters = (
  data:
    | GainMoreCustomersData
    | UpcomingFollowUpsData
    | OverdueNextActionDatesData,
): [
  IOption | undefined,
  IOption[],
  IOption | undefined,
  IOption[],
  IOption[],
] => {
  const {
    assigneeId,
    assigneeIds,
    assigneeName,
    assigneeNames,
    salesTeamId,
    salesTeamIds,
    salesTeamName,
    salesTeamNames,
    branches: branchInfo,
  } = data

  const assignee: IOption | undefined =
    assigneeId !== null && assigneeName !== null
      ? { label: assigneeName, value: assigneeId || '' }
      : undefined

  defaultGUIDValue

  const assignees: IOption[] = (assigneeIds || []).map((id, idx) => ({
    value: id === 'null' ? defaultGUIDValue : id,
    label: (assigneeNames || [])[idx],
  }))

  const salesTeam: IOption | undefined =
    salesTeamId !== null && salesTeamName !== null
      ? { label: salesTeamName, value: salesTeamId || '' }
      : undefined

  const salesTeams: IOption[] = (salesTeamIds || []).map((id, idx) => ({
    value: id,
    label: (salesTeamNames || [])[idx],
  }))

  const branches: IOption[] = (branchInfo || []).map((b) => ({
    value: b.id,
    label: b.name,
  }))

  return [assignee, assignees, salesTeam, salesTeams, branches]
}
